import React, { Component } from 'react'
import Link from 'gatsby-link';
import {ToolTip, HeaderItem} from './header-item'
import locale from '../../locale'
import { slide as Menu } from 'react-burger-menu'
import Img from 'gatsby-image'
import './header.css'


class Header extends Component {

  static onLanguageClick() {
    locale.setLocale(locale.isEnglish() ? locale.ALPHA_CHINESE : locale.ALPHA_ENGLISH);
    window.location.reload();
  }

  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
    }

    this.setMenuState = this.setMenuState.bind(this);
    this.updateStateOnResize = this.updateStateOnResize.bind(this);
    this.renderBurgerMenu = this.renderBurgerMenu.bind(this);
  }

  componentDidMount() {
    this.updateStateOnResize();
    window.addEventListener('resize', this.updateStateOnResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateStateOnResize);
  }

  updateStateOnResize() {
    if (typeof window !== 'undefined') {
      this.setMenuState(this.state.isMenuOpen && window.innerWidth < 770);
    }
  }

  setMenuState(isOpen) {
    this.setState({isMenuOpen : isOpen });
  }

  renderHeaderItem(data) {
    let hasLightBackground = typeof window !== 'undefined' ? window.location.pathname != '/' : true;

    return (
      <HeaderItem
        hasLightBackground = {hasLightBackground}
        title = {data.title}
        onClick = {data.isLanguageToggle ? Header.onLanguageClick : null}
        to = {data.to}
        children = {data.children}>
      </HeaderItem>
    )
  }

  renderHeaderItems(itemsData) {
    let items = itemsData.map(
      (itemData, index) =>
        <div key={index} className="header-item">
          {this.renderHeaderItem(itemData)}
        </div>
    );

    return (
      <div className="header-items">
        {items}
      </div>
    );
  }

  renderBMItemChildren(childrenData) {
    return (
      childrenData.map(
        (childData, index) =>

          <Link key = {index}
            className="bm-menu-item indent-twice"
            to = {childData.to}>
            {childData.title}
          </Link>
      )
    );
  }

  renderBMItem(data) {
    let children = data.children == null ? null : this.renderBMItemChildren(data.children);

    return (
      <div>

        <a
          className="bm-menu-item"
          onClick={data.isLanguageToggle ? Header.onLanguageClick : null}
          href = {data.to}>
          {data.title}
        </a>

        {children}

      </div>
    );
  }

  renderBMItems(itemsData) {
    return (
      itemsData.map(
        (itemData, index) =>
          <div key={index}>
            {this.renderBMItem(itemData)}
          </div>
        )
    );
  }

  renderBurgerMenu(items) {
    let hasLightBackground = typeof window !== 'undefined' ? window.location.pathname != '/' : true;

    let burgerStyles = {
      bmBurgerBars: {
        background: (hasLightBackground || this.state.isMenuOpen) ? 'black' : 'white',
      },
    }

    let onStateChange = (state) => {
  			document.querySelector('.bm-burger-button').classList.toggle('open');
        this.setMenuState(state.isOpen);
		};

    let burgerMenuItems = this.renderBMItems(items);

    return (
      <Menu
        styles = { burgerStyles }
        onStateChange={ onStateChange }
        isOpen= {this.state.isMenuOpen}
        height= {'100%'}
        width={'100%'} right
      >
        {burgerMenuItems}
      </Menu>
    );

  }

  renderLogo(logoSrc) {
    return (
      <a href="/" className="logo">
        <img src={logoSrc} width="200"/>
      </a>
    );
  }

  render() {
    let data = this.props.data;
    let logoSrc = this.props.src;
    console.log(logoSrc);
    let logo = this.renderLogo(logoSrc);
    let headerItems = this.renderHeaderItems(data);
    let burgerMenu = this.renderBurgerMenu(data);

    return (
      <div
        className="header clearfix"
        onMouseOver={this.props.mouseOverHeader}
        onMouseLeave = {this.props.mouseOffHeader}>

        {logo}

        {headerItems}

        {burgerMenu}

      </div>
    );
  }
}

export default {Header}



// WEBPACK FOOTER //
// ./src/components/Header/index.js